// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyProduct_root__oG_IC","show":"StickyProduct_show__p9Osg","text":"StickyProduct_text__wZMe_","toTopButton":"StickyProduct_toTopButton__NgzXm"};